import { ProductLicenseInfoResponse } from 'services/api/responses/responseTypes';
import { IProductLicenseInfo } from './iProductLicenseInfo';

export default class ProductLicenseInfo implements IProductLicenseInfo {
  title: string;

  description: string;

  constructor(data: ProductLicenseInfoResponse) {
    this.title = data.title;
    this.description = data.description;
  }
}
